<template>
    <span>
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <slot :activate="on" name="activator">
                <v-btn v-on="on">Download pdf</v-btn>
            </slot>
          </template>
              <v-card>
                <v-card-title class="headline grey lighten-2">
                    {{ $t('pdf.download.title', {number}) }}
                </v-card-title>

                <v-card-text>
                    <v-switch
                        v-model="materials"
                        :label="$t('pdf.download.materials')"
                        prepend-icon="mdi-hammer-screwdriver">
                    </v-switch>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">{{ $t('base.cancel') }}</v-btn>
                    <v-btn color="primary" text @click="download">{{ $t('base.download') }}</v-btn>
                </v-card-actions>
              </v-card>
        </v-dialog>
    </span>
</template>

<script>
export default {
    name: "Pdf",
    props: ['id', 'number'],
    data() {
        return {
            dialog: false,
            materials: false
        }
    },
    methods: {
        download() {
            this.$emit('downloading')
            this.dialog = false;
            this.$http({
                method: 'get',
                params: { materials: this.materials ? 1 : 0 },
                url: 'orders/' + this.id + '/pdf',
                responseType: 'blob'
            })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data]))
                    let fileLink = document.createElement('a')
                    fileLink.href = fileURL
                    fileLink.setAttribute('download', 'oferta_' + this.number + '.pdf')
                    document.body.appendChild(fileLink)
                    fileLink.click()
                    this.$emit('finished')
                })
                .catch(() => {
                    this.$emit('finished')
                })
        }
    }
}
</script>

<style scoped>

</style>
